import React from 'react'
import styled from 'styled-components';
import Anchor from '../components/general/anchor.component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';

const Paragraph = styled.p`
   font-size: 1.2em;
   margin: 0 0 2rem 0;
   color: rgb(107, 114, 128);
`;

const BiographyPage = () => (
   <VideoBehindText mainText="Biography" url="bg.jpg">
      <div className="grid w-11/12 sm:w-10/12 md:w-8/12 lg:w-5/12 mx-auto mt-4">
         <Paragraph>
            Ethan was born in 2004 and diagnosed completely blind since birth. As a toddler, he would explore the
            piano for hours imitating his first inspiration, Rowlf the piano-playing dog from the Muppet Show. His
            other inspiration, the DVD "Horowitz in Vienna", he played relentlessly.
            His formal piano lessons began at age 4 with his mother, but he now studies with Fali Pavri (Royal
            Conservatoire of Scotland). He has been composing since early childhood and loves to tell imaginative
            stories in his compositions.
         </Paragraph>
         <Paragraph>
            Ethan's first major concert was at a Music in Lanark event where he also debuted his first major
            composition work, "Wallace at Lanark" illustrating the life of Scottish hero William Wallace.
            Videos
            <Anchor url="https://www.youtube.com/watch?v=ybCVhJAyOec" text="here" />
            and
            <Anchor url="https://www.youtube.com/watch?v=eZ3pQ4ZQZa0" text="here" />.
         </Paragraph>
         <Paragraph>
            Ethan was the focus of a BBC radio documentary called
            <Anchor url="https://www.bbc.co.uk/programmes/b0709v4m" text="'Batman and Ethan'" />
            about the freedom a blind child can experience through working with the talented teacher of the
            blind, Daniel Kish.
         </Paragraph>
         <Paragraph>
            In 2016 Ethan was awarded his first major International award at the Vatican. He received the Premio
            Asoluto prize at the
            <Anchor url="https://www.youtube.com/watch?v=OTJ7zdAs3qw" text="15th International 'Giuseppe Sciacca' awards" />
            in Rome, for his ability to create music "full of colours" as an inspiration to all.
         </Paragraph>
         <Paragraph>
            In 2017 Ethan won the
            <Anchor url="https://www.loretto.com/the-seventh-james-waterhouse-loretto-piano-competition-and-master-classes2/52798.html"
               text="7th James Waterhouse Loretto Piano Competition" />
            "Advanced" class. As part of that
            prize, he performed at Steinway Hall in London.
         </Paragraph>
         <Paragraph>
            Ethan has twice participated in the wonderful Festival of Chopin in Mazovia, Poland. He won the 3rd and
            then the 4th categories. He performed at Chopin's house and later for the Warsaw Music Society.
         </Paragraph>
         <Paragraph>
            Ethan was a finalist in the EPTA Belgium International Piano Competition in 2018.
         </Paragraph>
         <Paragraph>
            In 2019 Ethan received his ATCL (Associate of Trinity College London) with a mark of 92/100 at the age of
            14.
         </Paragraph>
         <Paragraph>
            In July 2019 Ethan won the
            <Anchor url="https://www.youtube.com/watch?v=qEyl8yrLSeE" text="Scottish International Youth Piano Competition" />
            as part of the Moray Prize at
            the Royal Conservatoire of Scotland.
         </Paragraph>
         <Paragraph>
            Over covid lockdown 2020, every Saturday at 8PM Ethan showcased a short 15-minute concert on his YouTube channel.
            He recorded 44 concerts over the year.
         </Paragraph>
         <Paragraph>
            In 2022, after a year of competing Ethan won the 2022 BBC Young Musician Keyboard Category Final
            with the judges saying, “Ethan found orchestral colours on the piano like no-one else can.”
         </Paragraph>
         <Paragraph>
            Ethan was featured on The List, Top 100 People to Watch in 2022. <Anchor url="https://list.co.uk/news/42936/hot-100-list-2022-100-08" text="Link to article" />
         </Paragraph>
         <Paragraph>
            Ethan was featured in a wide ranging interview in the Music Teacher Magazine which can be read here 
            <Anchor 
            url="https://musicteachermagazine.co.uk/features/article/ethan-loch-interview-bbc-young-musician-finalist-on-vivid-dreams-perfect-pitch-and-barriers-to-access" 
            text="Link to article"/>.
         </Paragraph>
         <Paragraph>
            In the summer of 2023 Ethan was awarded a place at the Verbier Academy as a piano soloist.
         </Paragraph>
         <Paragraph>
            Ethan's first CD,
            <Anchor url="mpv1/index.html" text="'Mysterious Pathways Volume One'" />
            was featured on Classic FM and on a
            <Anchor url="https://www.cbc.ca/radio/thesundayedition/january-6-2019-the-sunday-edition-with-michael-enright-1.4964589/how-a-canadian-artist-captured-the-vision-of-a-blind-piano-prodigy-1.4964754"
               text="Canadian Broadcasting Corporation" />
            radio documentary featuring his collaboration with the Canadian artist
            <Anchor url="http://www.tonyluciani.ca/" text="Tony Luciani" />
            who painted the cover image.
         </Paragraph>
         <Paragraph>
            His second album,
            <Anchor url="https://amazon.co.uk/music/player/albums/B08R2SVFRX?marketplaceId=A1F83G8C2ARO7P&musicTerritory=GB&ref=dm_sh_hecPz58xYufaq18la3uPLM9bK"
               text="Mysterious Improvisations 2020" />, is a collection of one-shot, single-take classical improvisations.
         </Paragraph>
         <Paragraph>
            He has made three TV appearances to date. The first was on the One Show, and the second in May 2018 on the
            ITV show Little Big Shots where he enjoyed chatting to Dawn French and performing both on his own and as
            a duet with young Romanian singer and harpist Daria. His third appearance was on the BBC Young Musician 2022
            competition where he won the category final (keyboard) and performed the Chopin Piano Concerto No.1. The final
            was won by percussionist Jordan Ashman.
         </Paragraph>
         <Paragraph>
            Ethan is busy studying the Royal Conservatoire of Scotland and playing around the UK in both solo and concerto work.
            He has concerts in 2024 with the Bournemouth Symphony Orchestra with Mark Wigglesworth, Manchester Camerata Orchestra
            as a guest artist and the BBC Scottish Symphony Orchestra. In 2025 he is already booked to perform with the Royal
            Scottish National Orchestra. Please see the events page for details.
         </Paragraph>
      </div>
   </VideoBehindText>
);
export default BiographyPage;